import { useLocation } from 'react-router-dom'

export const useThreadRouteParams = () => {
  const { search } = useLocation()

  const urlParams = new URLSearchParams(search)
  const threadIdentifier = urlParams.get('thread')
  const replyIdentifier = urlParams.get('reply')

  const createThreadRoute = (commentId: string) => `?thread=${commentId}`

  const isThreadIdentifier = ({ identifier }: { identifier: string }) =>
    identifier === threadIdentifier

  return {
    isThreadRoute: !!threadIdentifier,
    threadIdentifier: threadIdentifier || undefined,
    replyIdentifier: replyIdentifier || undefined,
    createThreadRoute,
    isThreadIdentifier,
  }
}
